import script from "./Asistencias.vue?vue&type=script&setup=true&lang=js"
export * from "./Asistencias.vue?vue&type=script&setup=true&lang=js"

import "./Asistencias.vue?vue&type=style&index=0&id=65e7b5a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e7b5a2"]])

export default __exports__